import { render, staticRenderFns } from "./sidebarSearchesSaved.vue?vue&type=template&id=d771eb50&scoped=true&"
import script from "./sidebarSearchesSaved.vue?vue&type=script&lang=js&"
export * from "./sidebarSearchesSaved.vue?vue&type=script&lang=js&"
import style0 from "./sidebarSearchesSaved.vue?vue&type=style&index=0&id=d771eb50&lang=scss&scoped=true&"
import style1 from "./sidebarSearchesSaved.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d771eb50",
  null
  
)

export default component.exports